import { Control, Controller, UseFormSetValue } from 'react-hook-form';
import { ScheduleFormData } from '../../scheduling_types';
import { RepeatsEvery } from '../common/RepeatsEvery/RepeatsEvery';
import { LeftContainer, RightContainer } from '../common/styles';
import { RepeatTime } from '../common/RepeatTime/RepeatTime';
import { Box, Divider, Stack } from '@mui/material';
import { WhiteContainerWithShadow } from '../common/styles';
import { EffectiveDate } from '../common/EffectiveDate/EffectiveDate';
import { RepeatTypeSelector } from '../common/RepeatTypeSelector/RepeatTypeSelector';
import { IntervalAndSpecificDaysContainer } from './styles';
import IntervalField from '../common/IntervalField/IntervalField';
import BasedOn from '../common/BasedOn/BasedOn';
import { RecurrenceType } from 'models';


export interface MonthlyProps
{
	control: Control<any, any>;
	setValue: UseFormSetValue<ScheduleFormData>;
}


export const Monthly = ({ control, setValue }: MonthlyProps) =>
{
	return (
		<Stack
			direction='row'
			flexWrap='wrap'
			justifyContent='center'
			alignItems='center'
			gap={3}
		>
			<LeftContainer>
				<WhiteContainerWithShadow>
					<Controller
						control={control}
						name={'recurrence.recurrence_type'}
						defaultValue={RecurrenceType.SCHEDULE}
						render={({ field: { value, onChange } }) => {
							return (
								<Box>
									<RepeatTypeSelector
										control={control}
										value={value}
										onChange={onChange}
									/>
									<IntervalAndSpecificDaysContainer>
										{value === RecurrenceType.INTERVAL && (
											<IntervalField
												control={control}
												recurrence_unit='months'
											/>
										)}
										
										{value === RecurrenceType.SCHEDULE && (
											<Box>
												<RepeatsEvery
													control={control}
													isRequired={true}
													name={
														'monthly.specific_days'
													}
													unitLabel='Days'
													max={31}
													min={1}
												/>
												<Box sx={{ textAlign: 'end' }}>
													of the month
												</Box>
											</Box>
										)}
									</IntervalAndSpecificDaysContainer>
								</Box>
							);
						}}
					/>
				</WhiteContainerWithShadow>
			</LeftContainer>
			
			<Divider />
			
			<RightContainer>
				<RepeatTime
					control={control}
					setValue={setValue}
					defaultValue={new Date()}
				/>
				<EffectiveDate
					control={control}
					defaultValue={new Date()}
				/>
			</RightContainer>
		</Stack>
	);
};


interface IntervalProps
{
	control: Control<ScheduleFormData>;
}


export const Interval = ({ control }: IntervalProps) =>
{
	return (
		<>
			<RepeatsEvery
				control={control}
				name='monthly.interval.repeatsEvery'
				isRequired={true}
				unitLabel='months'
			/>
			<BasedOn
				control={control}
				name='monthly.interval.basedOn'
				defaultValue={'effective_date'}
				values={[
					{
						value: 'effective_date',
						label: 'Effective Date',
					},
					{
						value: 'last_completed_date',
						label: 'Last Completed Date',
					},
				]}
			/>
		</>
	);
};


export default Monthly;